import React, { useState, useContext, useEffect } from "react";
import ThowColumLayout from "../../layouts/ThowColumLayout";
import Sidebar from "../../components/Sidebar";
import Select from "../../components/Select";
import CircularSlider from "react-circular-slider-svg";

// import PieChart from "react-minimal-pie-chart";
// import { PieChart } from "react-minimal-pie-chart";
import HSBar from "react-horizontal-stacked-bar-chart";
import CardDivergences from "../../components/CardDivergences";
import HeaderDashboard from "../../components/HeaderDashboard";

import { DashboardsContext } from "../../context/dashboards";
import api from "../../services/api";
import { useTranslation } from "react-i18next";
import PercentageChart from "../../components/PercentageChart/PercentageChart";

const Dashboard = () => {
  const { t } = useTranslation();

  const [primaryPercent, setPrimaryPercent] = useState("");
  const [secondaryPercent, setSecondaryPercent] = useState("");
  const [threePercent, setThreePercent] = useState("");

  const [fourPercent, setFourPercent] = useState("");
  const [errorReasons, setErrorReasons] = useState([]);
  const [locations, setLocations] = useState([]);

  const [clientValue, setClientValue] = useState("");
  const [typeValue, setTypeValue] = useState("");
  const [locationValue, setLocationValue] = useState("");
  const [update, setUpdate] = useState(true);

  const {
    countsPerformed,
    progressCounts,
    countsMath,
    countsNotMath,
    countsLeftOver,
    getResumeProgress,
    getResumeProgressAccuracy,
    getResumeProgressDetails,
    countPrimary,
    countSecondary,
    countThree,
    countFour,
    getDivergencesDetails,
    operationError,
  } = useContext(DashboardsContext);

  const containerSecondary = {
    marginTop: "1.625rem",
    display: "flex",
    flexDirection: "column",
    overFlowY: "scroll",
    overFlowX: "hidden",
    alignItems: "center",
  };

  const containerResumeProgress = {
    marginTop: "1.625rem",
    width: "500px",
    height: "215px",
    border: "1px solid #D7D7D7",
    background: "white",
    paddingTop: "16px",
    paddingLeft: "14px",
    paddingRight: "14px",
    borderRadius: 7,
  };

  const containerInventary = {
    marginTop: "1.625rem",
    width: "500px",
    height: "387px",
    border: "1px solid #D7D7D7",
    background: "white",
    paddingTop: "16px",
    paddingLeft: "14px",
    overflowY: "auto",
    paddingRight: "14px",
    borderRadius: 7,
  };

  const containerSemiCircularSlider = {
    display: "flex",
    position: "relative",
    height: "120px",
  };

  const containerTexts = {
    marginTop: "0.3rem",
  };

  const boxContent = {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    justifyContent: "center",
  };

  const boxContainer = {
    display: "flex",
    alignItems: "center",
    gap: "20px",
  };

  const getPercent = async () => {
    const getPercent = await api.get("countage/percent");

    setPrimaryPercent(getPercent.data.primaryPercent);
    setSecondaryPercent(getPercent.data.secondaryPercent);
    setThreePercent(getPercent.data.threePercent);
    setFourPercent(getPercent.data.fourPercent);
  };

  const getUsers = async (e) => {
    if (e != undefined) {
      setClientValue(e);
      const response = await api.post("client/by/name", {
        name: e,
      });

      const getPercent = await api.get(`/countage/percent/client/${e}`);

      if (getPercent.status == 200) {
        setPrimaryPercent(getPercent.data.primaryPercent);
        setSecondaryPercent(getPercent.data.secondaryPercent);
        setThreePercent(getPercent.data.threePercent);
        setFourPercent(getPercent.data.fourPercent);
      }

      if (response.status == 200) {
        getResumeProgress(response.data[0].name);
        getResumeProgressAccuracy(response.data[0].name);
        getResumeProgressDetails(response.data[0].name);
        getDivergencesDetails(response.data[0].name);
      }
    }
  };

  const getTypes = async (e) => {
    setTypeValue(e);

    const response = await api.post("client/by/name", {
      name: clientValue,
    });

    const getPercent = await api.get(
      `/countage/percent/client/type/${clientValue}/${e}`
    );

    if (getPercent.status == 200) {
      setPrimaryPercent(getPercent.data.primaryPercent);
      setSecondaryPercent(getPercent.data.secondaryPercent);
      setThreePercent(getPercent.data.threePercent);
      setFourPercent(getPercent.data.fourPercent);
    }

    if (response.status == 200) {
      getResumeProgress(response.data[0].name, e);
      getResumeProgressAccuracy(response.data[0].name, e);
      getResumeProgressDetails(response.data[0].name, e);
      getDivergencesDetails(response.data[0].name, e);
    }
  };

  const getLocation = async (e) => {
    const selectLocation = await api.get(
      `/countage/select/location/${clientValue}/${typeValue}`
    );
    setLocations(selectLocation.data);
  };

  const getLocationDetails = async (e) => {
    setLocationValue(e);

    const response = await api.post("client/by/name", {
      name: clientValue,
    });

    const getPercent = await api.get(
      `/countage/percent/client/type/${clientValue}/${typeValue}/${e}`
    );

    if (getPercent.status == 200) {
      setPrimaryPercent(getPercent.data.primaryPercent);
      setSecondaryPercent(getPercent.data.secondaryPercent);
      setThreePercent(getPercent.data.threePercent);
      setFourPercent(getPercent.data.fourPercent);
    }

    if (response.status == 200) {
      getResumeProgress(response.data[0].name, typeValue, e);
      getResumeProgressAccuracy(response.data[0].name, typeValue, e);
      getResumeProgressDetails(response.data[0].name, typeValue, e);
      getDivergencesDetails(response.data[0].name, typeValue, e);
    }
  };

  const getErrorReasons = async () => {
    setErrorReasons([]);
    try {
      const response = await api.get("reason");

      setErrorReasons(response.data);
    } catch (error) {}
  };

  useEffect(() => {
    getErrorReasons();
  }, [clientValue, typeValue, locationValue]);

  useEffect(() => {
    getPercent();
  }, []);

  useEffect(() => {
    if (clientValue && typeValue) {
      getLocation();
    }
  }, [clientValue, typeValue]);

  // useContext(() => {
  //   // setUpdate(!update);
  //   console.log(countsMath, countsLeftOver, countsNotMath);
  // }, [countsMath, countsLeftOver, countsNotMath]);

  useEffect(() => {
    console.log(countsLeftOver, countsNotMath, countsMath);
  }, [countsLeftOver]);

  return (
    <ThowColumLayout
      name="Dashboard"
      page={"Dashboard"}
      background="#F9F9F9"
      colum1={
        <div>
          <Sidebar page="Dashboard" />
        </div>
      }
      colum2={
        <div style={containerSecondary}>
          <div
            style={{
              width: "1000px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <div
              style={{
                width: "1020px",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <HeaderDashboard name="Dashboard" />
              <div style={{ height: "25px" }} />

              <div style={{ display: "flex" }}>
                <div style={{ position: "relative" }}>
                  <div
                    style={{
                      display: "flex",
                      gap: "20px",
                      position: "absolute",
                    }}
                  >
                    <Select
                      type="user"
                      onChange={(e) => getUsers(e.target.value)}
                    />
                    <Select
                      type="count"
                      isActive={
                        clientValue && clientValue != "selecione" && true
                      }
                      onChange={(e) => getTypes(e.target.value)}
                    />
                    <Select
                      type="location"
                      values={
                        clientValue &&
                        clientValue != "selecione" &&
                        typeValue &&
                        typeValue != "selecione" &&
                        locations
                      }
                      onChange={(e) => getLocationDetails(e.target.value)}
                    />
                  </div>

                  <div style={{ height: "45px" }} />
                  <div style={containerResumeProgress}>
                    <p className="textPrimaryResumeProgress">
                      {t("countProgressSummary")}
                    </p>

                    <div style={{ position: "relative", top: "-15px" }}>
                      <svg
                        width="454"
                        height="1"
                        viewBox="0 0 454 1"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M0 1C0 0.447715 0.447715 0 1 0H453C453.552 0 454 0.447715 454 1H0Z"
                          fill="#E8E8E8"
                        />
                      </svg>
                    </div>

                    <div style={containerSemiCircularSlider}>
                      <div className="semi_circular_slider">
                        <CircularSlider
                          size={240}
                          minValue={0}
                          maxValue={100}
                          className="slider"
                          startAngle={90}
                          endAngle={270}
                          angleType={{
                            direction: "cw",
                            axis: "-y",
                          }}
                          handle1={{
                            value:
                              countsPerformed == undefined
                                ? 0
                                : countsPerformed,
                            onChange: (v) => <></>,
                          }}
                          arcColor="#123164"
                          arcBackgroundColor="#E5EAFC"
                        />
                        {countsPerformed == null ? (
                          <p className="text_semi_circular_slider">0%</p>
                        ) : (
                          <p className="text_semi_circular_slider">
                            {Number(countsPerformed).toFixed(2)}%
                          </p>
                        )}
                      </div>

                      <div style={containerTexts}>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                          }}
                        >
                          <div
                            style={{ display: "flex", alignItems: "center" }}
                          >
                            <svg
                              width="8"
                              height="9"
                              viewBox="0 0 8 9"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <rect
                                y="0.162109"
                                width="8"
                                height="8"
                                rx="4"
                                fill="#123164"
                              />
                            </svg>
                            <p className="textContDashboard">
                              {t("performedCount")}
                            </p>
                          </div>
                          {countsPerformed == null ? (
                            <p className="textContPercentage">0%</p>
                          ) : (
                            <p className="textContPercentage">
                              {Number(countsPerformed).toFixed(2)}%
                            </p>
                          )}
                        </div>

                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                          }}
                        >
                          <div
                            style={{ display: "flex", alignItems: "center" }}
                          >
                            <svg
                              width="8"
                              height="9"
                              viewBox="0 0 8 9"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <rect
                                y="0.162109"
                                width="8"
                                height="8"
                                rx="4"
                                fill="#123164"
                              />
                            </svg>
                            <p className="textContDashboard">
                              {t("progressCount")}
                            </p>
                          </div>
                          {isNaN(progressCounts) ? (
                            <p className="textContPercentage">0%</p>
                          ) : (
                            <p className="textContPercentage">
                              {Number(progressCounts).toFixed(2)}%
                            </p>
                          )}
                        </div>
                        {Number(countsPerformed) > 99.99 && (
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                            }}
                          >
                            <div
                              style={{ display: "flex", alignItems: "center" }}
                            >
                              <svg
                                width="8"
                                height="9"
                                viewBox="0 0 8 9"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <rect
                                  y="0.162109"
                                  width="8"
                                  height="8"
                                  rx="4"
                                  fill="#123164"
                                />
                              </svg>
                              <p className="textContDashboard">
                                {t("finishedCounting")}
                              </p>
                            </div>
                            {isNaN(progressCounts) ? (
                              <p className="textContPercentage">0%</p>
                            ) : (
                              <p className="textContPercentage">
                                {Number(countsPerformed).toFixed(2)}%
                              </p>
                            )}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>

                  <div style={containerInventary}>
                    <p className="textPrimaryResumeProgress">
                      {t("inventoryAccuracy")}
                    </p>

                    <div style={{ position: "relative", top: "-15px" }}>
                      <svg
                        width="454"
                        height="1"
                        viewBox="0 0 454 1"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M0 1C0 0.447715 0.447715 0 1 0H453C453.552 0 454 0.447715 454 1H0Z"
                          fill="#E8E8E8"
                        />
                      </svg>
                    </div>

                    <div style={boxContainer}>
                      <div style={boxContent}>
                        <svg
                          width="9"
                          height="8"
                          viewBox="0 0 9 8"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <rect
                            x="0.0766602"
                            width="8"
                            height="8"
                            rx="4"
                            fill="#123164"
                          />
                        </svg>
                        <p className="textTitleInventary">Contagem OK</p>
                      </div>
                      <div style={boxContent}>
                        <svg
                          width="9"
                          height="8"
                          viewBox="0 0 9 8"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <rect
                            x="0.358887"
                            width="8"
                            height="8"
                            rx="4"
                            fill="#476EE6"
                          />
                        </svg>

                        <p className="textTitleInventary">Sobras</p>
                      </div>
                      <div style={boxContent}>
                        <svg
                          width="9"
                          height="8"
                          viewBox="0 0 9 8"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <rect
                            x="0.641113"
                            width="8"
                            height="8"
                            rx="4"
                            fill="#EA0000"
                          />
                        </svg>

                        <p className="textTitleInventary">Faltas</p>
                      </div>
                    </div>

                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                      }}
                    >
                      {(countsMath || countsLeftOver || countsNotMath) && (
                        <PercentageChart
                          listMonthsTwo={[
                            countsMath,
                            countsLeftOver,
                            countsNotMath,
                          ]}
                        />
                      )}
                      {/* {countsLeftOver && (
                        // <PieChart
                        //   lineWidth={40}
                        //   rounded={true}
                        //   paddingAngle={37}
                        //   style={{
                        //     width: "220px",
                        //     height: "220px",
                        //   }}
                        //   label={(item) => {
                        //     if (item.data[0].value != undefined) {
                        //       if (item.key === "label-0") {
                        //         return `${item.data[0].value}%`;
                        //       }
                        //       if (item.key === "label-1") {
                        //         return `${item.data[1].value}%`;
                        //       }
                        //       if (item.key === "label-2") {
                        //         return `${item.data[2].value}%`;
                        //       }
                        //     }
                        //   }}
                        //   labelPosition={78}
                        //   labelStyle={{
                        //     fontWeight: 600,
                        //     fontSize: "6px",
                        //     fill: "white",
                        //   }}
                        //   data={[
                        //     {
                        //       title: "One",
                        //       value: Number(countsLeftOver),
                        //       color: "#476EE6",
                        //     },
                        //     {
                        //       title: "Two",
                        //       value: Number(countsNotMath),
                        //       color: "#C13C37",
                        //     },
                        //     {
                        //       title: "Three",
                        //       value: Number(countsMath),
                        //       color: "#123164",
                        //     },
                        //   ]}
                        // />
                        <PieChart
                          lineWidth={40} // Largura da linha
                          rounded={true} // Borda arredondada
                          paddingAngle={37} // Ângulo de preenchimento
                          style={{
                            width: "220px",
                            height: "220px",
                          }}
                          labelPosition={78} // Posição do rótulo
                          labelStyle={{
                            fontWeight: 600,
                            fontSize: "6px",
                            fill: "white",
                          }}
                          // label={(item) => {
                          //   console.log(item);
                          //   if (item.data[0].value != undefined) {
                          //     if (item.key === "label-0") {
                          //       return `${item.data[0].value}%`;
                          //     }
                          //     if (item.key === "label-1") {
                          //       return `${item.data[1].value}%`;
                          //     }
                          //     if (item.key === "label-2") {
                          //       return `${item.data[2].value}%`;
                          //     }
                          //   }
                          // }}
                          data={[
                            {
                              title: "One",
                              value: Number(countsLeftOver),
                              color: "#476EE6",
                            },
                            {
                              title: "Two",
                              value: Number(countsNotMath),
                              color: "#C13C37",
                            },
                            {
                              title: "Three",
                              value: Number(countsMath),
                              color: "#123164",
                            },
                          ]}
                        />
                      )} */}
                    </div>
                  </div>

                  <div style={{ height: "90px" }}></div>
                </div>

                <div style={{ marginLeft: "1.18rem" }}>
                  <div style={{ height: "45px" }}></div>
                  <div style={containerResumeProgress}>
                    <p className="textPrimaryResumeProgress">
                      {t("counProgressDetails")}
                    </p>

                    <div style={{ position: "relative", top: "-15px" }}>
                      <svg
                        width="454"
                        height="1"
                        viewBox="0 0 454 1"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M0 1C0 0.447715 0.447715 0 1 0H453C453.552 0 454 0.447715 454 1H0Z"
                          fill="#E8E8E8"
                        />
                      </svg>
                    </div>
                    <HSBar
                      height={50}
                      outlineWidth={0.4}
                      outlineColor="white"
                      id="new_id"
                      data={[
                        {
                          value: primaryPercent,
                          color: "#123164",
                        },

                        {
                          value: secondaryPercent,
                          color: "#2457AB",
                        },

                        {
                          value: threePercent,
                          color: "#5193FF",
                        },

                        {
                          value: fourPercent,
                          color: "#5193FF",
                        },
                      ]}
                    />

                    <div
                      style={{
                        display: "flex",
                        marginTop: "0.9rem",
                        justifyContent: "space-around",
                      }}
                    >
                      <div style={{ display: "flex" }}>
                        <div style={{ position: "relative", top: "-1px" }}>
                          <svg
                            width="8"
                            height="9"
                            viewBox="0 0 8 9"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <rect
                              y="0.162109"
                              width="8"
                              height="8"
                              rx="4"
                              fill="#123164"
                            />
                          </svg>
                        </div>

                        <div>
                          <p className="textPrimaryCount">{t("oneCount")}</p>
                          {countPrimary == null ? (
                            <p className="textPercentageCount">{`${Number(
                              primaryPercent
                            ).toFixed(2)}%`}</p>
                          ) : (
                            <p className="textPercentageCount">
                              {Number(primaryPercent).toFixed(2)}%
                            </p>
                          )}
                        </div>
                      </div>

                      <div style={{ display: "flex", marginLeft: "2rem" }}>
                        <div style={{ position: "relative", top: "-1px" }}>
                          <svg
                            width="8"
                            height="9"
                            viewBox="0 0 8 9"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <rect
                              y="0.162109"
                              width="8"
                              height="8"
                              rx="4"
                              fill="#2457AB"
                            />
                          </svg>
                        </div>

                        <div>
                          <p className="textPrimaryCount">{t("twoCount")}</p>

                          {countSecondary == null ? (
                            <p className="textPercentageCount">{`${Number(
                              secondaryPercent
                            ).toFixed(2)}%`}</p>
                          ) : (
                            <p className="textPercentageCount">
                              {Number(countSecondary).toFixed(2)}%
                            </p>
                          )}
                        </div>
                      </div>

                      <div style={{ display: "flex", marginLeft: "2rem" }}>
                        <div style={{ position: "relative", top: "-1px" }}>
                          <svg
                            width="8"
                            height="9"
                            viewBox="0 0 8 9"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <rect
                              y="0.162109"
                              width="8"
                              height="8"
                              rx="4"
                              fill="#5193FF"
                            />
                          </svg>
                        </div>

                        <div>
                          <p className="textPrimaryCount">{t("threeCount")}</p>
                          {countThree == null ? (
                            <p className="textPercentageCount">{`${Number(
                              threePercent
                            ).toFixed(2)}%`}</p>
                          ) : (
                            <p className="textPercentageCount">
                              {Number(countThree).toFixed(2)}%
                            </p>
                          )}
                        </div>
                      </div>

                      <div style={{ display: "flex", marginLeft: "2rem" }}>
                        <div style={{ position: "relative", top: "-1px" }}>
                          <svg
                            width="8"
                            height="9"
                            viewBox="0 0 8 9"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <rect
                              y="0.162109"
                              width="8"
                              height="8"
                              rx="4"
                              fill="#99C0FF"
                            />
                          </svg>
                        </div>

                        <div>
                          <p className="textPrimaryCount">{t("fourCount")}</p>
                          {countFour == null ? (
                            <p className="textPercentageCount">
                              {Number(fourPercent).toFixed(2)}%
                            </p>
                          ) : (
                            <p className="textPercentageCount">
                              {Number(fourPercent).toFixed(2)}%
                            </p>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div style={containerInventary}>
                    <p className="textPrimaryResumeProgress">
                      {t("mainReasonsForDivergences")}
                    </p>

                    <div style={{ position: "relative", top: "-15px" }}>
                      <svg
                        width="454"
                        height="1"
                        viewBox="0 0 454 1"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M0 1C0 0.447715 0.447715 0 1 0H453C453.552 0 454 0.447715 454 1H0Z"
                          fill="#E8E8E8"
                        />
                      </svg>
                    </div>

                    {errorReasons.map((item) => {
                      return (
                        <CardDivergences
                          client={clientValue}
                          type={typeValue}
                          location={locationValue}
                          percentage={operationError}
                          number={operationError}
                          name={item.reason}
                        />
                      );
                    })}
                  </div>

                  <div style={{ height: "90px" }}></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      }
    ></ThowColumLayout>
  );
};

export default Dashboard;
